/**
 * Users API
 */
import apiClient from './index'
import type {
  ApiResponse,
  PaginatedResponse,
  PaginationParams,
  User,
  UserCreateData,
  UserUpdateData,
  TeamCapacity,
} from '@/types'

export const usersApi = {
  /**
   * List users with pagination
   */
  async list(params?: PaginationParams & { is_active?: boolean }): Promise<PaginatedResponse<User>> {
    const response = await apiClient.get<PaginatedResponse<User>>('/users', { params })
    return response.data
  },

  /**
   * Get user by ID
   */
  async get(id: string): Promise<User> {
    const response = await apiClient.get<ApiResponse<User>>(`/users/${id}`)
    return response.data.data
  },

  /**
   * Create a new user
   */
  async create(data: UserCreateData): Promise<User> {
    const response = await apiClient.post<ApiResponse<User>>('/users', data)
    return response.data.data
  },

  /**
   * Update a user
   */
  async update(id: string, data: UserUpdateData): Promise<User> {
    const response = await apiClient.put<ApiResponse<User>>(`/users/${id}`, data)
    return response.data.data
  },

  /**
   * Delete a user
   */
  async delete(id: string): Promise<void> {
    await apiClient.delete(`/users/${id}`)
  },

  /**
   * Get team capacity
   */
  async getCapacity(): Promise<TeamCapacity[]> {
    const response = await apiClient.get<ApiResponse<TeamCapacity[]>>('/users/capacity')
    return response.data.data
  },
}
